export const carevincoBrand = {
  logo: "/assets/brand/carevinco-logo-horizontal.png",
  mark: "/favicon.png",
  width: 260,
  height: 64,
} as const;
